import { q } from 'groqd'

export const legalTextQuery = q('*')
  .filter('_type == "legalText" && _id == $id')
  .grab({
    _type: q.literal('legalText'),
    market: q.string(),
    heading: ['heading[$lang]', q.string()],
    key: ['key.current', q.string()],
    content: ['content[$lang]', q.array(q.unknown()).nullable()],
    contentHtml: ['contentHtml[$lang]', q.string().nullable()],
  })
  .slice(0)
